export default [
    {
        key: 'CustomDimensionIssuedModal',
        getComponent: function () { return import('./CustomDimensionIssuedModal'); },
        title: i18n.get('自定义档案'),
        width: 600,
        maskClosable: false,
        wrapClassName: 'vertical-center-modal select-member-modal',
    },
    {
        key: 'CustomDimensionAutoIssuedModal',
        getComponent: function () { return import('./CustomDimensionAutoIssuedModal'); },
        title: i18n.get('自动下发规则'),
        width: 600,
        maskClosable: false,
        wrapClassName: 'vertical-center-modal select-member-modal',
    },
    {
        key: 'CustomDimensionConditionModal',
        getComponent: function () { return import('./CustomDimensionConditionModal'); },
        title: i18n.get('自定义档案'),
        width: 600,
        maskClosable: false,
        wrapClassName: 'vertical-center-modal select-member-modal',
    },
    {
        key: 'LogModal',
        getComponent: function () { return import('./LogModal'); },
        title: '下发记录',
        width: 800,
    },
];
